import { Box, Text, Image, ScrollView } from '@bonanza-social/moonlight';
import { Page } from '@bonanza-social/navigation';
import privacyPolicySections from './PrivacyPolicy.content';
import { Trans } from '@bonanza-social/i18n';
import { Link } from 'react-router';

function PrivacyPolicy() {
  return (
    <Page>
      <ScrollView>
        <Box
          alignItems="center"
          paddingBottom="space-600"
          paddingHorizontal="space-400"
        >
          <Box width="100%" maxWidth={767} flexDirection="column">
            <Box
              width="100%"
              height={225}
              position="relative"
              justifyContent="center"
              alignItems="center"
            >
              <Image
                name="misc.crystals"
                width="100%"
                height={225}
                contentFit="cover"
              />
            </Box>

            <Box flexDirection="column" gap="space-400" paddingTop="space-400">
              <Text
                variant="h4"
                gradient="darkSurfaceAccent"
                locNS="account"
                locKey="privacyHeader"
                marginBottom="space-400"
              />

              <Text variant="body-m" color="darkSurfacePrimary">
                Last Updated: 10 Dec 2025
              </Text>

              {privacyPolicySections.map(({ headerKey, textKey }) => (
                <Box
                  key={headerKey}
                  flexDirection="column"
                  marginTop="space-400"
                  marginBottom="space-600"
                >
                  <Text
                    variant="h5"
                    gradient="darkSurfaceAccent"
                    locNS="account"
                    locKey={headerKey}
                    marginBottom="space-300"
                  />

                  {textKey ? (
                    textKey === 'privacySection7Text' ? (
                      <Text variant="body-m" color="darkSurfacePrimary">
                        <Trans
                          ns="account"
                          i18nKey={textKey}
                          components={{
                            privacyRightsContactLink: (
                              <Link
                                to="/contact"
                                style={{
                                  color: 'inherit',
                                  textDecoration: 'underline',
                                }}
                              />
                            ),
                          }}
                        />
                      </Text>
                    ) : (
                      <Text
                        variant="body-m"
                        color="darkSurfacePrimary"
                        locNS="account"
                        locKey={textKey}
                      />
                    )
                  ) : null}
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </ScrollView>
    </Page>
  );
}

export default PrivacyPolicy;
